import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("App crashed:", error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "100vh",
            fontFamily: "sans-serif",
            color: "#2a366d",
            gap: "12px",
          }}>
          <h2>Something went wrong</h2>
          <p style={{ color: "#666", fontSize: "14px", maxWidth: 400, textAlign: "center" }}>
            The page failed to load. Try refreshing — if the problem persists,
            contact support.
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{
              padding: "8px 20px",
              background: "#2a366d",
              color: "#fff",
              border: "none",
              borderRadius: 4,
              cursor: "pointer",
            }}>
            Refresh
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
